/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2019, 2023. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */

// mixin the dynamic byoc params if the yml preprocessor is enabled...
function mixinDynamicByocParams(options, context, params) {
  if (context.enableYmlPreprocessor === true) {
    options.enableYmlPreprocessor = true;
    options.source_provider = params.source_provider || null;
    options.app_repo = params.app_repo || null;
    options.workspaceId = params.workspaceId || null;
    options.params = {};
    // inject additional params on the query that aren't
    // already specified on the options...
    var EXCLUDE_PARAMS_TEMPLATE = /(repo[s\u017F]itory|ba[s\u017F]eName|env_id|zip_url|templateType|app_id|branch|tenant|toolchainId|[s\u017F]ource_provider|pipeline_type|app_repo|wor[k\u212A][s\u017F]paceId)/i;
    Object.keys(params).forEach(function (param) {
      if (EXCLUDE_PARAMS_TEMPLATE.exec(param) === null) {
        // if the options doesn't have it then add it...
        if (options[param] === undefined) {
          options.params[param] = params[param];
        }
      }
    });
  }
}
function isPublicTemplate(repo) {
  var isPublicRegex = /(github\.com(\/|\%2F)open-toolchain)|(\.git\.cloud\.ibm\.com)/;
  return isPublicRegex.test(repo);
}
function isComplianceTemplate(repo) {
  var isComplianceRegex = /\/(iac-)?compliance-c(i|d|c)-toolchain/;
  return isComplianceRegex.test(repo);
}
function isSecureAppTemplate(repo) {
  var isSecureAppRegex = /\/secure-app-toolchain/;
  return isSecureAppRegex.test(repo);
}
function isSimpleVSITemplate(repo) {
  var isSimpleVSIRegex = /\/simple-vsi-toolchain/;
  return isSimpleVSIRegex.test(repo);
}
function isComplianceIntegrationTemplate(repo) {
  var isCIRegex = /\/compliance-ci-toolchain/;
  return isCIRegex.test(repo);
}
function isComplianceIntegrationTemplateForIaC(repo) {
  var isCIRegex = /\/iac-compliance-ci-toolchain/;
  return isCIRegex.test(repo);
}
function isComplianceDeploymentTemplate(repo) {
  var isCDRegex = /\/compliance-cd-toolchain/;
  return isCDRegex.test(repo);
}
function isContinuousComplianceTemplate(repo) {
  var isCCRegex = /\/compliance-cc-toolchain/;
  return isCCRegex.test(repo);
}
module.exports = {
  isComplianceTemplate: isComplianceTemplate,
  isComplianceIntegrationTemplate: isComplianceIntegrationTemplate,
  isComplianceIntegrationTemplateForIaC: isComplianceIntegrationTemplateForIaC,
  isComplianceDeploymentTemplate: isComplianceDeploymentTemplate,
  isContinuousComplianceTemplate: isContinuousComplianceTemplate,
  isPublicTemplate: isPublicTemplate,
  isSecureAppTemplate: isSecureAppTemplate,
  isSimpleVSITemplate: isSimpleVSITemplate,
  mixinDynamicByocParams: mixinDynamicByocParams
};